export default __webpack_public_path__ + "static/media/IMG_3566.7d4b6061.jpg";